import { Navigate, useLocation } from 'react-router-dom';

interface PrivateRouteProps {
  children: React.ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const location = useLocation();
  
  const isAuthenticated = () => {
    const authFlag = localStorage.getItem('isAuthenticated') === 'true';
    const authTimestamp = localStorage.getItem('authTimestamp');
    
    if (!authFlag || !authTimestamp) {
      return false;
    }

    // Optional: Check if authentication is expired (e.g., after 24 hours)
    const now = Date.now();
    const timestamp = parseInt(authTimestamp);
    const timeLimit = 24 * 60 * 60 * 1000; // 24 hours
    
    if (now - timestamp > timeLimit) {
      localStorage.removeItem('isAuthenticated');
      localStorage.removeItem('authTimestamp');
      return false;
    }

    return true;
  };

  if (!isAuthenticated()) {
    // Redirect to login while saving the attempted URL
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default PrivateRoute; 